import { createSlice } from "@reduxjs/toolkit";
import {
  DropDownList,
  GetBranchesResponse,
  BranchesDetails,
} from "utils/types";

interface BusinessBranchesTypes {
  businessBranchesAccess: DropDownList[];
  businessAllBranches: DropDownList[];
  branchesAccessDetails: GetBranchesResponse[];
}

// initial state
const initialState: BusinessBranchesTypes = {
  businessBranchesAccess: [],
  businessAllBranches: [],
  branchesAccessDetails: [],
};

const BusinessBranches = createSlice({
  name: "businessBranches",
  initialState,
  reducers: {
    setBusinessBranchesAccess(state, action) {
      state.businessBranchesAccess = action.payload;
    },
    setBusinessAllBranches(state, action) {
      state.businessAllBranches = action.payload;
    },
    setBranchesAccessDetails(state, action) {
      state.branchesAccessDetails = action.payload;
    },
    resetBusinessBranchesAccess(state) {
      state.businessBranchesAccess = [];
    },
    resetBusinessAllBranches(state) {
      state.businessAllBranches = [];
    },
    resetBranchesAccessDetails(state) {
      state.businessAllBranches = [];
    },
  },
});

export default BusinessBranches.reducer;

export const {
  setBusinessBranchesAccess,
  setBusinessAllBranches,
  setBranchesAccessDetails,
  resetBusinessBranchesAccess,
  resetBusinessAllBranches,
  resetBranchesAccessDetails,
} = BusinessBranches.actions;
